import { TransactionColumnDefinition } from "@reporting/rp-types/analytics";
import { ResultSpecs, TransactionTotalItem } from "../types";
import { findColumnIndex } from "../common";

export class TransactionResult {

	private _data: string[][] | null = null;
	private _columns: TransactionColumnDefinition[] | null = null;
	private _totals: TransactionTotalItem[] | null = null;

	get columns() { return this._columns }
	get data() { return this._data }
	get totals() { return this._totals }

	public addResultSet(resultSpec: ResultSpecs<TransactionColumnDefinition>, data: string[][]) {
		if (resultSpec.tableType == 'transactions') {
			this._columns = resultSpec.columns;
			this._data = data;
		} else if (resultSpec.tableType == 'totals') {
			const nameIndex = findColumnIndex(resultSpec.columns, 'NAME');
			const columnIndex = findColumnIndex(resultSpec.columns, 'COLUMN');
			const formatIndex = findColumnIndex(resultSpec.columns, 'FORMAT');
			const valueIndex = findColumnIndex(resultSpec.columns, 'VALUE');

			this._totals = data.map(row => ({
				name: row[nameIndex],
				column: row[columnIndex],
				format: row[formatIndex],
				value: Number(row[valueIndex]),
			}));
		}
	}

}
